// Copyright (c) Proto Labs, Inc. All Rights Reserved.
import { Log as OidcLog, UserManager as OidcUserManager, } from 'oidc-client-ts';
import { UserProxy } from './UserProxy';
export class UserManagerProxy {
    constructor(settings, logger) {
        this.userManager = new OidcUserManager(this.getAsUserManagerSettings(settings));
        OidcLog.setLogger(logger);
        OidcLog.setLevel(settings.logLevel);
    }
    async getUserAsync() {
        const origUser = await this.userManager.getUser();
        return origUser ? new UserProxy(origUser) : null;
    }
    removeUserAsync() {
        return this.userManager.removeUser();
    }
    revokeAccessTokenAsync() {
        return this.userManager.revokeTokens();
    }
    async signinCallbackAsync(url) {
        await this.userManager.signinCallback(url);
    }
    signinRedirectAsync(args) {
        return this.userManager.signinRedirect(args);
    }
    async signinSilentAsync(args) {
        await this.userManager.signinSilent(args);
    }
    signoutRedirectAsync(args) {
        return this.userManager.signoutRedirect(args);
    }
    registerAddUserLoaded(callback) {
        this.userManager.events.addUserLoaded((user) => {
            callback(new UserProxy(user));
        });
    }
    registerAddUserSignedOut(callback) {
        this.userManager.events.addUserSignedOut(callback);
    }
    registerAddUserUnloaded(callback) {
        this.userManager.events.addUserUnloaded(callback);
    }
    getAsUserManagerSettings(settings) {
        return {
            acr_values: settings.acrValues,
            authority: settings.authority,
            automaticSilentRenew: settings.automaticSilentRenew,
            client_id: settings.clientId,
            loadUserInfo: settings.loadUserInfo,
            monitorSession: settings.monitorSession,
            post_logout_redirect_uri: settings.postLogoutRedirectUri,
            redirect_uri: settings.redirectUri,
            response_type: settings.responseType,
            revokeTokensOnSignout: settings.revokeTokensOnSignout,
            scope: settings.scope,
            stopCheckSessionOnError: settings.stopCheckSessionOnError,
            filterProtocolClaims: settings.filterProtocolClaims,
        };
    }
}
//# sourceMappingURL=UserManagerProxy.js.map